export default class BookFilter {
    constructor(title, author, publishYear, categories, ownerId) {
        this.title = title
        this.author = author
        this.publishYear = publishYear
        this.categories = categories
        this.ownerId = ownerId
    }
}